/**
 * Le nom que la plateforme affiche : titre du menu, écran de connexion,
 * objet des courriels, émetteur du code à deux facteurs.
 *
 * Le nom imprimé en tête des documents, lui, est un paramètre réglé en
 * Configuration (`general.nom_etablissement`) ; ce nom-ci n'en est que la
 * valeur par défaut.
 */
export const NOM_PLATEFORME = 'AFS SMIE';
//# sourceMappingURL=marque.js.map